import React from 'react'
import { Layout } from 'antd'
import VoidChecksForm from './components/VoidChecksForm'
import VoidChecksResultTable from './components/VoidChecksResultTable'
import { useVoidChecksContext } from './index.context'
import './index.scss'

const VoidChecksContent: React.FC = () => {
  const { hasSearched } = useVoidChecksContext()
  
  return (
    <Layout.Content
      className='void-checks-container'
      style={{
        padding: '24px',
        flex: 1,
      }}
    >
      <VoidChecksForm />
      <div style={{ marginTop: 24, display: hasSearched ? 'block' : 'none' }} >
        <VoidChecksResultTable />
      </div>
    </Layout.Content>
  )
}

export default VoidChecksContent
